module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABcAQMAAAARYWiIAAAABlBMVEUAAABVVVUT3Vn+AAAAAXRSTlMAQObYZgAAADdJREFUeAFjIBOMAvsHB/jnf2B+cP7HMRvmf/wNBvXHD35g/zMMZEZlRmVGZUZlRmVGZcgDowAAdQZsetU5NV4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/RegisterExtension/OrderConfirmation/barcode.png
// module id = 1046
// module chunks = 1